if (!customElements.get('ss-choice-counts')) {
  customElements.define('ss-choice-counts', class extends HTMLElement {
    connectedCallback() {
      const counters = [...this.querySelectorAll('[data-count-pending]')];
      if (!counters.length) return;
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      const current = new URL(window.location.href);
      const url = new URL(current.pathname, current.origin);
      url.searchParams.set('view', 'ss-choice-counts');
      for (const key of ['country', 'currency']) {
        if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      }
      const previewId = current.searchParams.get('preview_theme_id') || this.dataset.previewThemeId;
      if (previewId) url.searchParams.set('preview_theme_id', previewId);
      fetch(url.href, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'text/html' } })
        .then(response => {
          if (!response.ok) throw new Error('Counts unavailable');
          return response.text();
        })
        .then(html => {
          if (!this.isConnected || controller.signal.aborted) return;
          const source = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ss-counts-source]');
          if (source?.dataset.ssCountsSource !== this.dataset.collectionId) return;
          const totals = new Map();
          for (const item of source.querySelectorAll('[data-count-total]')) {
            if (!/^[0-9]+$/.test(item.dataset.countTotal)) continue;
            totals.set(JSON.stringify([item.dataset.countParam, item.dataset.countValue]), item.dataset.countTotal);
          }
          for (const counter of counters) {
            const total = totals.get(JSON.stringify([counter.dataset.countParam, counter.dataset.countValue]));
            if (total === undefined) continue;
            counter.textContent = total;
            counter.removeAttribute('data-count-pending');
          }
        })
        .catch(() => {});
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
